/* A link only works on the host that minted its token — send someone a preview link and
   they get "invalid tracking link". So shout about it before it reaches a customer. */
import { AlertTriangle } from "lucide-react";

export const isPreviewHost = () => {
  const h = window.location.hostname || "";
  return h.includes("preview.emergentagent.com") || h === "localhost" || h.startsWith("127.");
};

export const PreviewLinkWarning = ({ what = "link" }) => {
  if (!isPreviewHost()) return null;
  return (
    <div className="border-2 border-red-700 !bg-red-600 !text-white px-3 py-2 mono text-[11px] leading-snug" data-testid="preview-link-warning">
      <AlertTriangle className="w-3.5 h-3.5 inline mr-1.5 align-[-2px]" />
      <b className="uppercase">You're on the preview site</b> — this {what} won't work for them.
      Send it from your live site (armorbatch.com) instead.
    </div>
  );
};
